import script from "./LembretesView.vue?vue&type=script&setup=true&lang=js"
export * from "./LembretesView.vue?vue&type=script&setup=true&lang=js"

import "./LembretesView.vue?vue&type=style&index=0&id=e63b7686&lang=css"

const __exports__ = script;

export default __exports__